import { useEffect, useState } from "react";
import { listCompanies } from "../../api/users/companies";

const CompanySearch = ({ open, onClose, onSelect }) => {
  const [companies, setCompanies] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [query, setQuery] = useState("");

  // 회사 목록 불러오기
  const loadCompanies = async () => {
    try {
      const res = await listCompanies();
      const data = res?.data ?? res;
      const rows = Array.isArray(data) ? data : data?.results ?? [];
      setCompanies(rows);
      setFiltered(rows);
    } catch (error) {
      console.error("회사 목록 불러오기 실패:", error);
    }
  };

  useEffect(() => {
    if (open) loadCompanies();
  }, [open]);

  // 검색 필터
  const handleSearch = (e) => {
    const val = e.target.value;
    setQuery(val);
    if (!val.trim()) {
      setFiltered(companies);
    } else {
      setFiltered(
        companies.filter((c) =>
          c.name.toLowerCase().includes(val.toLowerCase())
        )
      );
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
        <h2 className="text-lg font-bold mb-4">회사 검색</h2>

        {/* 검색 입력 */}
        <input
          type="text"
          placeholder="회사명을 입력하세요"
          value={query}
          onChange={handleSearch}
          className="w-full border rounded-md px-3 py-2 mb-4"
        />

        {/* 회사 리스트 */}
        <div className="max-h-64 overflow-y-auto border rounded">
          {filtered.length === 0 ? (
            <div className="p-4 text-gray-500 text-sm">검색 결과 없음</div>
          ) : (
            <ul>
              {filtered.map((c) => (
                <li
                  key={c.id}
                  className="flex justify-between items-center px-3 py-2 border-b hover:bg-gray-50"
                >
                  <span>{c.name}</span>
                  <button
                    type="button"
                    onClick={() => {
                      onSelect(c);
                      onClose();
                    }}
                    className="text-blue-600 text-sm hover:underline"
                  >
                    선택
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* 닫기 버튼 */}
        <div className="flex justify-end mt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanySearch;
